import { MapObject } from "../ui/map-view";
import { useMap } from "react-leaflet";
import { useRef } from "react";
import { useEffect } from "react";

export const AutoZoomToSingleObject: React.FC<{ objects?: MapObject[] }> = ({ objects }) => {
  const map = useMap();
  const prevObjId = useRef<MapObject["id"] | null>(null);

  useEffect(() => {
    if (objects && objects.length === 1) {
      const obj = objects[0];
      if (String(prevObjId.current) !== String(obj.id)) {
        map.setView([obj.lat, obj.lon], 17, { animate: true });
        prevObjId.current = obj.id;
      }
    } else {
      prevObjId.current = null;
    }
  }, [objects, map]);
  return null;
};
